import { ReactComponent as TurnLeftIcon } from 'assets/icons/directions/turn-left.svg';
import { ReactComponent as TurnRightIcon } from 'assets/icons/directions/turn-right.svg';
import { ReactComponent as UTurnRightIcon } from 'assets/icons/directions/u-turn-right.svg';
import { ReactComponent as UTurnLeftIcon } from 'assets/icons/directions/u-turn-left.svg';
import { ReactComponent as TurnSlightRightIcon } from 'assets/icons/directions/turn-slight-right.svg';
import { ReactComponent as MergeIcon } from 'assets/icons/directions/merge.svg';
import { ReactComponent as RoundaboutLeftIcon } from 'assets/icons/directions/roundabout-left.svg';
import { ReactComponent as RoundaboutRightIcon } from 'assets/icons/directions/roundabout-right.svg';
import { ReactComponent as TurnSlightLeftIcon } from 'assets/icons/directions/turn-slight-left.svg';
import { ReactComponent as RampRightIcon } from 'assets/icons/directions/ramp-right.svg';
import { ReactComponent as ForkRightIcon } from 'assets/icons/directions/fork-right.svg';
import { ReactComponent as StraightIcon } from 'assets/icons/directions/straight.svg';
import { ReactComponent as ForkLeftIcon } from 'assets/icons/directions/fork-left.svg';
import { ReactComponent as FerryTrainIcon } from 'assets/icons/directions/ferry-train.svg';
import { ReactComponent as TurnSharpRightIcon } from 'assets/icons/directions/turn-sharp-right.svg';
import { ReactComponent as TurnSharpLeftIcon } from 'assets/icons/directions/turn-sharp-left.svg';
import { ReactComponent as RampLeftIcon } from 'assets/icons/directions/ramp-left.svg';
import { ReactComponent as FerryIcon } from 'assets/icons/directions/ferry.svg';
import React from 'react';

export const ROUTE_MANEUVERS = [
  'MANEUVER_UNSPECIFIED',
  'TURN_SLIGHT_LEFT',
  'TURN_SHARP_LEFT',
  'UTURN_LEFT',
  'TURN_LEFT',
  'TURN_SLIGHT_RIGHT',
  'TURN_SHARP_RIGHT',
  'UTURN_RIGHT',
  'TURN_RIGHT',
  'STRAIGHT',
  'RAMP_LEFT',
  'RAMP_RIGHT',
  'MERGE',
  'FORK_LEFT',
  'FORK_RIGHT',
  'FERRY',
  'FERRY_TRAIN',
  'ROUNDABOUT_LEFT',
  'ROUNDABOUT_RIGHT',
  'DEPART',
  'NAME_CHANGE',
] as const;

export type RouteManeuver = (typeof ROUTE_MANEUVERS)[number];

export const isRouteManeuver = (value?: string | null): value is RouteManeuver => {
  if (!value) {
    return false;
  }

  return ROUTE_MANEUVERS.includes(value as RouteManeuver);
};

export const GetDirectionIcon = (type?: RouteManeuver | null) => {
  switch (type) {
    case 'TURN_LEFT':
      return <TurnLeftIcon />;
    case 'TURN_RIGHT':
      return <TurnRightIcon />;
    case 'UTURN_RIGHT':
      return <UTurnRightIcon />;
    case 'UTURN_LEFT':
      return <UTurnLeftIcon />;
    case 'TURN_SLIGHT_RIGHT':
      return <TurnSlightRightIcon />;
    case 'TURN_SLIGHT_LEFT':
      return <TurnSlightLeftIcon />;
    case 'TURN_SHARP_RIGHT':
      return <TurnSharpRightIcon />;
    case 'TURN_SHARP_LEFT':
      return <TurnSharpLeftIcon />;
    case 'MERGE':
      return <MergeIcon />;
    case 'ROUNDABOUT_LEFT':
      return <RoundaboutLeftIcon />;
    case 'ROUNDABOUT_RIGHT':
      return <RoundaboutRightIcon />;
    case 'RAMP_RIGHT':
      return <RampRightIcon />;
    case 'RAMP_LEFT':
      return <RampLeftIcon />;
    case 'FORK_RIGHT':
      return <ForkRightIcon />;
    case 'FORK_LEFT':
      return <ForkLeftIcon />;
    case 'FERRY_TRAIN':
      return <FerryTrainIcon />;
    case 'FERRY':
      return <FerryIcon />;
    case 'STRAIGHT':
    case 'DEPART':
    case 'NAME_CHANGE':
      return <StraightIcon />;

    case 'MANEUVER_UNSPECIFIED':
    default:
      return null;
  }
};
